import { DatePipe } from '@angular/common';
import { Component, computed, HostListener, OnInit, signal } from '@angular/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { LoadingSpinnerComponent } from '../../../../shared/components/forms/loading-spinner/loading-spinner.component';
import { SkeletonLoaderComponent } from '../../../../shared/components/skeleton-loader/skeleton-loader.component';
import { AnimateOpenDirective } from '../../../../shared/directives/animate-open.directive';
import { MmrService } from '../../services/mmr.service';

@Component({
  selector: 'app-history',
  imports: [AnimateOpenDirective, DatePipe, ButtonComponent, SkeletonLoaderComponent, LoadingSpinnerComponent],
  templateUrl: './history.component.html',
  styleUrl: './history.component.scss',
  host: {
    class: 'p-24 md-p-16',
  },
})
export class HistoryComponent implements OnInit {
  openPanels = signal<Record<number, boolean>>({});
  showFullList = signal(false);
  private readonly isMobile = signal(window.innerWidth <= 640);

  @HostListener('window:resize')
  onResize() {
    this.isMobile.set(window.innerWidth <= 640);
  }

  readonly viewModel = computed(() => {
    const historySignal = this.mmrService?.planClaimsDetails?.history;
    const historyValue = historySignal?.value() ?? [];
    const isHistorySlow = this.mmrService?.planClaimsDetails?.historySlowLoadTriggered();
    const limit = this.isMobile() ? 2 : 3;

    return {
      isLoading: historySignal?.isLoading(),
      isError: !!historySignal?.error(),
      openPanels: this.openPanels(),
      isEmpty: historyValue.length === 0,
      showExpandOption: historyValue.length > limit,
      entries: this.showFullList() ? historyValue : historyValue.slice(0, limit),
      showTimeoutMessage: isHistorySlow,
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly mmrService: MmrService) {}

  ngOnInit() {
    this.mmrService.loadHistory.set(true);
  }
  updateOpenPanels(index: number): void {
    this.openPanels.update((value) => {
      return {
        ...value,
        [index]: !this.openPanels()[index],
      };
    });
  }

  retry(): void {
    // this.mmrService.planClaimsDetails.history.reload();
  }
}
